export {}

declare global {
  interface Map<K, V> {
    toList(): Array<[K, V]>
  }
}

Map.prototype.toList = function(): Array<[any, any]> {
  return Array.from((this as Map<any, any>).entries())
}
